import { LAMPORTS_PER_SOL } from '@solana/web3.js';
import usePersistStore from './zustand-store/persist-config/usePersistStore';

export const NUMBER_OF_RESERVED_TOKEN = 10 ** 9;
export const DEFAULT_PARTY_TIME_NORMAL_CURVE = 1;
export const DEFAULT_SOL_PARTY_LIMIT_IDO = 100;
export const DEFAULT_SOL_PARTY_LIMIT_AGENTS = 1;
export const TOTAL_SUPPLY_TOKEN = 1_000_000_000;
export const DEFAULT_TOKEN_IDO_CURVE = 750;
export const DEFAULT_TOKEN_IDO_CURVE_MIN = 500;
export const DEFAULT_TOKEN_IDO_CURVE_MAX = 5000;

export const DEFAULT_TOKEN_INIT_IDO_CURVE = 910;
export const TX_TIME_VALID = 2 * 60; // 2 min

export enum MODE_COIN {
  CTO,
  DEGEN,
}

export enum MODE_COIN_TEXT {
  CTO = 'cto',
  DEGEN = 'degen',
  NONE = '',
}

export const MAP_MODE_COIN_TO_KEY = {
  [MODE_COIN_TEXT.CTO]: MODE_COIN.CTO,
  [MODE_COIN_TEXT.DEGEN]: MODE_COIN.DEGEN,
};

export const WAITING_FOR_CREATE_TOKEN_TIME = 2000;
export const AXIOS_TIMEOUT = 30000;

export const SOL_PRICE_KEY = 'SOL_PRICE_KEY';

export const SOLANA_ENV = import.meta.env.VITE_APP_SOLANA_ENV || 'mainnet-beta';

export const EVM_DECIMAL = 18;
export const SPL_DECIMAL = 6;
export const SOL_DECIMAL = 9;
export const MAX_RETRY_QUERY_TOKEN = 3;
export const LIMIT_PAGINATION = 8;
export const SEED_GLOBAL = 'global';
export const TX_FEE = 0.25;
export const SEED_CURVE_VAULT = 'curve_vault';

export const ORAI_TOKEN = {
  address: {
    cosmos: 'orai',
    evm: 'orai',
  },
  name: 'ORAI',
  symbol: 'ORAI',
  decimals: {
    cosmos: 6,
    evm: 18,
  },
  image: 'https://images.orai.io/logo/orai-token.png',
};

/**
 * STRONGBOX VAULT
 */
export const STRONG_BOX_VAULT_SEED = 'staking_vault';
export const STRONG_BOX_STAKE_CONFIG_SEED = 'staking_config';
export const STAKER_INFO_SEED = 'staker_info';
export const STAKE_DETAIL_SEED = 'stake_detail';

/**
 * FUNGIBLE LOCK
 */
export const FUNGIBLE_VAULT_SEED = 'staking_vault';
export const FUNGIBLE_STAKE_CONFIG_SEED = 'staking_config';
export const STAKE_FUNGIBLE_INFO_SEED = 'stake_info';

export const DEFAI_STAKE_VAULT_SEED = 'staking_vault';
export const DEFAI_STAKE_INFO_SEED = 'stake_info';
/**
 * MEME STAKE
 */
export const MEME_STAKE_VAULT_SEED = 'staking_vault';
export const MEME_STAKE_INFO_SEED = 'stake_info';

/**
 * MEME launchpad
 */
export const TOKEN_CREATOR_SEED = 'token_creator';

export const PARRY_STATUS = 'party_status';

export const TOKEN_WITH_AGENT_CLAN = {
  oraiBbhuMd7MeVxyBjtnK8sggprf2NpHkeJaeHzpBFK: '@BankerADL', // banker
  oraiTJ6XxoLpxXSM98defqVA7Z3QRLvFjYJFs1yB6im: '@FUDBOI', // fudboi
  oraiUNrTQmeuc13JoMFSyNcJCnXYpqErfp9v5diy64b: '@VanguardInsight', // vanguard
  orairHM3Yw2PbTfCty1PXy7tEUx3uBMfjouNbm4KnRJ: '@jpowai', // jpowai
  oraix39mVDGnusyjag97Tz5H8GvGriSZmhVvkvXRoc4: '@leequid', // leequid
  oraiJP7H3LAt57DkFXNLDbLdBFNRRPvS8jg2j5AZkd9: '@gnrt', // gnrt
  D7yP4ycfsRWUGYionGpi64sLF2ddZ2JXxuRAti2M7uck: '@blackrack', // blackrack
};
export const CTO_COIN_OLD_VERSION = [
  'moonznxqtXdzA81shGf6EQ8Rw36hgaoqRUeWREDYiVe',
  'moonGvQw19jXedkQFf5qgdzSRCZvNv2eNbmvR6ZwSkk',
];
export const BLACK_LIST_ADDRESS = [
  'orairNRBJU7eUFRU7dSCZJxCzWKErZvvBfybmeeDmu7', // TrendMaximizer by MAX ($TMAX)

  'oraigyiRnYoCgFiaLnpiaPvJjZbs5zzmWHp4sxBgZq3', // BlackRack
  'Au2AaBHBJ2b5E9eERrff58Byspu4Esg7CxJYrkNBeZa6', // TSM
  'orai8zK5jjKuprnXkFxwX9tJKseQw3gmrK5rCbotSb3', // Test DEFAI
  'E5ZP8VcErWYB1sGiyBFe1bZbNoom6f47dDXW71fehKYW', //  Test DEFAI
  'Cy9Nbb57WrtxXBfzKWkzZx7AZG1YcxYRkHhWXvMGNMaK', // test upcoming
  'u6QsSskdwQ4mEyy2ACpyxNwrSy9Sz2vU3XoPpMEDkQH', // test upcoming
  // gen test

  'BRqRVPwtyndv2vaWNFjDSv8fH7Rccnfeo8uw5RxSbjUt',
  '7XKfaPix942j4iuJcB57yNb9eUCJEk8arLzReBy8Wq83',
  'APwbeogTeENbdLZM4xsFZuwEGWn8zVRLVzuPziQfEMoS',
  '4YAUi3ZnjeHmNx1LUxsavxxAHvFExX8ep72hJtDNKkU2',
  'DbKiFv3JkZSCtmcMWnTo3NzCApUKaXkKaWq2441JNETi',
  '88FR4czxf7syvNsrEQZ9cLP2AFnxodFfGmXNsbdJQCBn',
  'HgZWwzuUwRKScwvdncp2aG5kkQKnWEQKQHsagRf8qCkn',
  'GvF2U3ZQmsVagRP4FrgD7ETjwTutBeSdCVQM9CzTG8XD',
  '6ypXJsniSKVrynxwLqtJkBdVhZj6m3yE4A6fNJbrRoa',
  '9UTMesxqi2cv7cXXkswrksnsFff65dB41B7ve6EWppJU',
  '3NdUk319N7aKSyVt8LsJvupeeuYn8ojhC9uwyJqmoeTe',
  '2s72rmFpx8B48jDzw2pDrdUgGra3YmFH6bWnubhgvkuU',
  'DzvehmQYSzd4bAmwkge9GoLSN6abxP8Xvie6YTbnu7EQ',
  'AR9hpPi7jn4QwZVUUDm1kC9GSpmL1pqV5ofpwzbpWaEH',
  '5u4BdDHAPKTgw2aaQxVYsojmJGsEUNWxsT9xJChBpcaL',
  'MNg5gaa36GXZTgbAemn2aMiRoDct54TkrfDX8Kz6UpC',
  '7exZSwq17Kg3aC4Q1QtQYVrvj6nu5XivcKEDnjtU3mVB',
  'FLbuiaNtsmhm28Aq5Pg2RYvZof7pFp9aYFF1mr6PJGs6',
  'HrVAhZEeVaJiBoDVQELDiugiavjJFXMfsEqTjievSccE',
  'Bxn23vGQzhG12Bk3xMPvRx8PdgFgggb4fs2CGsfkZrQd',
  'moonDTw9py9Ucbteo7MG1sZVuUxJjEcG7Jp2YkoHyJg',
];

export const SCAM_REPORTED_TOKENS = [
  'BQi7eXQyXTYDdrpA22pLeCNQrm3B8kdFtPnAxSSN4Pw1',
  '31JZ7FRRSQR4YNd6jdbwUPRJX4YqmrKBLgaTs2dpY74e',

  // prod
  'oraih14KsWGQgwXEtEvrmNLEmNQfn9iPJDkLHV5Ldnm',
];

// export const OFFICIAL_TIME = 1735059600000; // time go live 0h00 - 25/12/2024
// export const OFFICIAL_TIME = 1735059600; // time go live

export const MAX_INTEGER = 99999 * LAMPORTS_PER_SOL;
export const MAX_UTIL_URL = '/max';
export const TRADING_DEFI_URL = '/trading'; // '/trading-defai';

export const isEvmNetwork = usePersistStore.getState().currentNetwork === 'evm';
export const COEFF_PRICE_PUBLIC_IDO = 1.2;
export const BASIS_POINT = 10000;

export const CONFIGS: Record<
  string,
  {
    FACTORY_TOKEN_PREFIX: string;
    PROGRAM_ID: string;
    MEME_LAUNCHPAD_PROGRAM_ID: string;
    DISTILL_COMMUNITY_POOL_WALLET: string;
    STAKE_CURRENCY_DECIMALS: number;
    STAKE_CURRENCY_MINT: string;
    ADL_TREASURY_WALLET: string;
    ADL_TREASURY_EVM_WALLET: string;
    STRONGBOX_VAULT_PROGRAM_ID: string;
    BONDING_CURVE_LIMIT: number;
    INIT_SOL_BONDING_CURVE: number;
    MEME_BONDING_CURVE_LIMIT: number;
    MEME_INIT_SOL_BONDING_CURVE: number;
    DEFAI_BONDING_CURVE: number;
    DEGEN_BONDING_CURVE_LIMIT: number;
    DEGEN_INIT_SOL_BONDING_CURVE: number;
    DEFAULT_PARTY_TIME_IDO_CURVE: number;
    DEFAULT_SOL_IDO_CURVE: number;
    TIMER: {
      MILLISECONDS: number;
      MONTH_TO_SECONDS: number;
      HAFT_MILLISECOND: number;
      MILLISECOND: number;
      SECOND: number;
      MINUTE: number;
      HOUR: number;
      DAY_TO_SECONDS: number;
    };
    SHOW_DECIMALS_PRICE: number;
    OFFICIAL_TIME: number;
    LOCK_FUNGIBLE_STAKE: number;
    STAKE_SOFT_CAP: number;
    STAKING_PROGRAM_ID: string;
    CHARITY_ADDRESS: string;
    TIME_TO_LAUNCH_UPCOMING_TOKEN: number;
  }
> = {
  // localnet keys are in cli/local-scripts/
  localnet: {
    FACTORY_TOKEN_PREFIX:
      'factory/orai1466nf3zuxpya8q9emxukd7vftaf6h4psr0a07srl5zw74zh84yjqtsu49d',
    CHARITY_ADDRESS: 'GE6TdivytMj2QsXSgrSVFLFGMUdHdXzpvEffRRo8ENnD',
    PROGRAM_ID: 'agentDiuyLRQEZgByNRnDErj1FcXyfyZysaQBDfwNNM',
    MEME_LAUNCHPAD_PROGRAM_ID: 'agentUwfaSU5MatYzTr9cJ67Pi5uddAaUqcda359ZvP',
    DISTILL_COMMUNITY_POOL_WALLET:
      'ADRbQMzWXQiXocmTj67HCHubyYWrEdLbZcjZKUChoSEc',
    STAKE_CURRENCY_DECIMALS: 6,
    STAKE_CURRENCY_MINT: isEvmNetwork
      ? '0xEbA77223a5A2e1Ec2A3579364fE3a43CEF713AB8'
      : '8NHfoL9NjSNwBRKCCrDBmbqByFoaZ1AcMJ6Dn17CWqWx',
    ADL_TREASURY_WALLET: 'AKb1kRLav9Lx7i4mZvXmjGGQFZVaaUwzfk4uyJhZ8kYz',
    ADL_TREASURY_EVM_WALLET: '0x8c7E0A841269a01c0Ab389Ce8Fb3Cf150A94E797',
    STRONGBOX_VAULT_PROGRAM_ID: '9grg8RG2prncny136yjDMy5BZcwhB4NvqGMGDFs7QtKy',
    BONDING_CURVE_LIMIT: 85 * LAMPORTS_PER_SOL,
    INIT_SOL_BONDING_CURVE: 3 * LAMPORTS_PER_SOL,
    MEME_BONDING_CURVE_LIMIT: 115 * LAMPORTS_PER_SOL,
    MEME_INIT_SOL_BONDING_CURVE: 30 * LAMPORTS_PER_SOL,
    DEFAI_BONDING_CURVE: 135,
    DEGEN_BONDING_CURVE_LIMIT: 260 * LAMPORTS_PER_SOL,
    DEGEN_INIT_SOL_BONDING_CURVE: 60 * LAMPORTS_PER_SOL,
    DEFAULT_PARTY_TIME_IDO_CURVE: 24,
    DEFAULT_SOL_IDO_CURVE: 1744,
    TIMER: {
      MILLISECONDS: 1000,
      MONTH_TO_SECONDS: 60,
      HAFT_MILLISECOND: 500,
      MILLISECOND: 1000,
      SECOND: 60,
      MINUTE: 60,
      HOUR: 24,
      DAY_TO_SECONDS: 24 * 60 * 60,
    },
    SHOW_DECIMALS_PRICE: 9,
    OFFICIAL_TIME: 1735059600000,
    LOCK_FUNGIBLE_STAKE: 300,
    STAKE_SOFT_CAP: 5000000,
    STAKING_PROGRAM_ID: 'CmM3iSUBXGnURkHiG6DneSp8fkvkxy5L9oqfTUhMxV7u',
    TIME_TO_LAUNCH_UPCOMING_TOKEN: 1 * 24 * 60 * 60 * 1000,
  },
  devnet: {
    FACTORY_TOKEN_PREFIX:
      'factory/orai1466nf3zuxpya8q9emxukd7vftaf6h4psr0a07srl5zw74zh84yjqtsu49d',
    CHARITY_ADDRESS: 'GE6TdivytMj2QsXSgrSVFLFGMUdHdXzpvEffRRo8ENnD',
    PROGRAM_ID: 'agentDiuyLRQEZgByNRnDErj1FcXyfyZysaQBDfwNNM',
    MEME_LAUNCHPAD_PROGRAM_ID: 'agentUwfaSU5MatYzTr9cJ67Pi5uddAaUqcda359ZvP',
    DISTILL_COMMUNITY_POOL_WALLET:
      'CyokHgfzAWYaaFR2P37hfHz3H3RRF6u9A6RNhWraSyoN',
    STAKE_CURRENCY_DECIMALS: 6,
    STAKE_CURRENCY_MINT: isEvmNetwork
      ? '0xf053c62335eE126B37165bD32B052e31ddbE176A' // decimal 6
      : '3Ff7yUkQsbMzViXu7aAxAYsgpy31wY8R8TteE39FDuw4',
    ADL_TREASURY_WALLET: 'AKb1kRLav9Lx7i4mZvXmjGGQFZVaaUwzfk4uyJhZ8kYz',
    ADL_TREASURY_EVM_WALLET: '0x8c7E0A841269a01c0Ab389Ce8Fb3Cf150A94E797',
    STRONGBOX_VAULT_PROGRAM_ID: '9grg8RG2prncny136yjDMy5BZcwhB4NvqGMGDFs7QtKy',
    BONDING_CURVE_LIMIT: 260 * LAMPORTS_PER_SOL,
    INIT_SOL_BONDING_CURVE: 60 * LAMPORTS_PER_SOL,
    MEME_BONDING_CURVE_LIMIT: 260 * LAMPORTS_PER_SOL,
    MEME_INIT_SOL_BONDING_CURVE: 60 * LAMPORTS_PER_SOL,
    DEFAI_BONDING_CURVE: 135,
    DEGEN_BONDING_CURVE_LIMIT: 260 * LAMPORTS_PER_SOL,
    DEGEN_INIT_SOL_BONDING_CURVE: 60 * LAMPORTS_PER_SOL,
    DEFAULT_PARTY_TIME_IDO_CURVE: 0.25,
    DEFAULT_SOL_IDO_CURVE: 1.744,
    TIMER: {
      MILLISECONDS: 1000,
      MONTH_TO_SECONDS: 60,
      HAFT_MILLISECOND: 500,
      MILLISECOND: 1000,
      SECOND: 60,
      MINUTE: 60,
      HOUR: 24,
      DAY_TO_SECONDS: 24 * 60 * 60,
    },
    SHOW_DECIMALS_PRICE: 9,
    OFFICIAL_TIME: 1735059600000,
    LOCK_FUNGIBLE_STAKE: 300,
    STAKE_SOFT_CAP: 5000000,
    STAKING_PROGRAM_ID: 'CmM3iSUBXGnURkHiG6DneSp8fkvkxy5L9oqfTUhMxV7u',
    TIME_TO_LAUNCH_UPCOMING_TOKEN: 5 * 60 * 1000, // 5mins
  },
  'mainnet-beta': {
    FACTORY_TOKEN_PREFIX:
      'factory/orai1466nf3zuxpya8q9emxukd7vftaf6h4psr0a07srl5zw74zh84yjqtsu49d',
    CHARITY_ADDRESS: 'GE6TdivytMj2QsXSgrSVFLFGMUdHdXzpvEffRRo8ENnD',
    PROGRAM_ID: 'agentDiuyLRQEZgByNRnDErj1FcXyfyZysaQBDfwNNM',
    MEME_LAUNCHPAD_PROGRAM_ID: 'agentUwfaSU5MatYzTr9cJ67Pi5uddAaUqcda359ZvP',
    DISTILL_COMMUNITY_POOL_WALLET:
      'HJbs8zNyiMQP46S1MrcVsyPQs9hDnf5bcmscU1rPxi3d',
    STAKE_CURRENCY_DECIMALS: 6,
    STAKE_CURRENCY_MINT: isEvmNetwork
      ? '0xEbA77223a5A2e1Ec2A3579364fE3a43CEF713AB8'
      : 'oraim8c9d1nkfuQk9EzGYEUGxqL3MHQYndRw1huVo5h',
    ADL_TREASURY_WALLET: 'AKb1kRLav9Lx7i4mZvXmjGGQFZVaaUwzfk4uyJhZ8kYz',
    ADL_TREASURY_EVM_WALLET: '0x8c7E0A841269a01c0Ab389Ce8Fb3Cf150A94E797',
    STRONGBOX_VAULT_PROGRAM_ID: 'Fke77idjs2D92Ha6uGJKfe94z62nDgjY3mHGsm9kskiH',
    BONDING_CURVE_LIMIT: 260 * LAMPORTS_PER_SOL,
    INIT_SOL_BONDING_CURVE: 60 * LAMPORTS_PER_SOL,
    MEME_BONDING_CURVE_LIMIT: 260 * LAMPORTS_PER_SOL,
    MEME_INIT_SOL_BONDING_CURVE: 60 * LAMPORTS_PER_SOL,
    DEFAI_BONDING_CURVE: 135,
    DEGEN_BONDING_CURVE_LIMIT: 260 * LAMPORTS_PER_SOL,
    DEGEN_INIT_SOL_BONDING_CURVE: 60 * LAMPORTS_PER_SOL,
    DEFAULT_PARTY_TIME_IDO_CURVE: 24,
    DEFAULT_SOL_IDO_CURVE: 1744,
    TIMER: {
      MILLISECONDS: 1000,
      MONTH_TO_SECONDS: 30 * 24 * 60 * 60,
      HAFT_MILLISECOND: 500,
      MILLISECOND: 1000,
      SECOND: 60,
      MINUTE: 60,
      HOUR: 24,
      DAY_TO_SECONDS: 24 * 60 * 60,
    },
    SHOW_DECIMALS_PRICE: 9,
    OFFICIAL_TIME: 1735059600000,
    LOCK_FUNGIBLE_STAKE: 14 * 86400,
    STAKE_SOFT_CAP: 5000000,
    STAKING_PROGRAM_ID: 'CmM3iSUBXGnURkHiG6DneSp8fkvkxy5L9oqfTUhMxV7u',
    TIME_TO_LAUNCH_UPCOMING_TOKEN: 3 * 24 * 60 * 60 * 1000,
  },
  'mainnet-beta-test': {
    FACTORY_TOKEN_PREFIX:
      'factory/orai1466nf3zuxpya8q9emxukd7vftaf6h4psr0a07srl5zw74zh84yjqtsu49d',
    CHARITY_ADDRESS: 'GE6TdivytMj2QsXSgrSVFLFGMUdHdXzpvEffRRo8ENnD',
    PROGRAM_ID: 'agentDiuyLRQEZgByNRnDErj1FcXyfyZysaQBDfwNNM',
    MEME_LAUNCHPAD_PROGRAM_ID: 'agentUwfaSU5MatYzTr9cJ67Pi5uddAaUqcda359ZvP',
    DISTILL_COMMUNITY_POOL_WALLET:
      'HJbs8zNyiMQP46S1MrcVsyPQs9hDnf5bcmscU1rPxi3d',
    STAKE_CURRENCY_DECIMALS: 6,
    STAKE_CURRENCY_MINT: isEvmNetwork
      ? '0xEbA77223a5A2e1Ec2A3579364fE3a43CEF713AB8'
      : 'oraim8c9d1nkfuQk9EzGYEUGxqL3MHQYndRw1huVo5h',
    ADL_TREASURY_WALLET: 'AKb1kRLav9Lx7i4mZvXmjGGQFZVaaUwzfk4uyJhZ8kYz',
    ADL_TREASURY_EVM_WALLET: '0x8c7E0A841269a01c0Ab389Ce8Fb3Cf150A94E797',
    STRONGBOX_VAULT_PROGRAM_ID: 'Fke77idjs2D92Ha6uGJKfe94z62nDgjY3mHGsm9kskiH',
    BONDING_CURVE_LIMIT: 260 * LAMPORTS_PER_SOL,
    INIT_SOL_BONDING_CURVE: 60 * LAMPORTS_PER_SOL,
    MEME_BONDING_CURVE_LIMIT: 115 * LAMPORTS_PER_SOL,
    MEME_INIT_SOL_BONDING_CURVE: 30 * LAMPORTS_PER_SOL,
    DEFAI_BONDING_CURVE: 135,
    DEGEN_BONDING_CURVE_LIMIT: 260 * LAMPORTS_PER_SOL,
    DEGEN_INIT_SOL_BONDING_CURVE: 60 * LAMPORTS_PER_SOL,
    DEFAULT_PARTY_TIME_IDO_CURVE: 0.25,
    DEFAULT_SOL_IDO_CURVE: 1.744,
    TIMER: {
      MILLISECONDS: 1000,
      MONTH_TO_SECONDS: 30 * 24 * 60 * 60,
      HAFT_MILLISECOND: 500,
      MILLISECOND: 1000,
      SECOND: 60,
      MINUTE: 60,
      HOUR: 24,
      DAY_TO_SECONDS: 24 * 60 * 60,
    },
    SHOW_DECIMALS_PRICE: 12,
    OFFICIAL_TIME: 1735059600000,
    LOCK_FUNGIBLE_STAKE: 86400 * 14,
    STAKE_SOFT_CAP: 5000000,
    STAKING_PROGRAM_ID: 'CmM3iSUBXGnURkHiG6DneSp8fkvkxy5L9oqfTUhMxV7u',
    TIME_TO_LAUNCH_UPCOMING_TOKEN: 10 * 60 * 1000, // 10mins
  },
};
export const AGENT_AUTHORITY_ADDRESS =
  'BEhX8iDgWz8YHDr8dhCQcvxfv2shjxUDxnvnpVsh63XS';
export const ALL_CONFIGS = CONFIGS[SOLANA_ENV] || CONFIGS['mainnet-beta'];

export const PROGRAM_ID = ALL_CONFIGS.PROGRAM_ID ?? '';
export const MEME_LAUNCHPAD_PROGRAM_ID =
  ALL_CONFIGS.MEME_LAUNCHPAD_PROGRAM_ID ?? '';

const MEME_TOKENOMICS = [
  {
    text: '0.5% for GNRT stakers for tokens launched by GNRT AI Agent',
    color: '#f98f8f',
  },
  {
    text: '0.5% for GNRT AI Agent',
    color: '#f9b48f',
  },
  {
    text: '1% for Distilled AI Treasury',
    color: '#f9dd8f',
  },
  {
    text: '1% for Agents(dot)land Charity',
    color: '#C2F98F',
  },
  {
    text: '2% for Strongbox Vault',
    color: '#9EEEDB',
  },
  {
    text: '95% for fairlaunch (bonding curve)',
    color: '#7e9af9',
  },
];

const RIZA_TOKENOMICS = [
  {
    text: '1% for Agent Wallet',
    color: '#f98f8f',
  },
  {
    text: '1% for Distilled AI Treasury',
    color: '#f9b48f',
  },
  {
    text: '2% for Strongbox Vault',
    color: '#f9dd8f',
  },
  {
    text: '11% for for DEX Liquidity',
    color: '#C2F98F',
  },
  {
    text: '17% for Creator (5% at TGE, 5% at listing, 2% at 1M market cap, 2% at 5M market cap, 2% at 10M market cap and 1%  at 20M market)',
    color: '#9EEEDB',
  },
  {
    text: '18% for lock in DAO',
    color: '#7e9af9',
  },
  {
    text: '50% for fairlaunch (bonding curve)',
    color: '#3e9af9',
  },
];

const RIZA_TOKENOMICS_V2 = [
  {
    text: '1% for Agent Wallet',
    color: '#f98f8f',
  },
  {
    text: '1% for Distilled AI Treasury',
    color: '#f9b48f',
  },
  {
    text: '2% for Strongbox Vault',
    color: '#f9dd8f',
  },
  {
    text: '17% Creator (5% at TGE, 5% at listing, 2% at 1m market cap, 2% at 5m market cap, 2% at 10m market cap and 1%  at 20m market)',
    color: '#C2F98F',
  },
  {
    text: '79% Fair launch/Liquidity',
    color: '#9EEEDB',
  },
];

const REGULAR_TOKENOMICS = [
  {
    text: '5% for creator',
    color: '#f9b48f',
  },
  {
    text: '1% for Distilled AI Treasury',
    color: '#f9dd8f',
  },
  {
    text: '1% for Agent Wallet',
    color: '#C2F98F',
  },
  {
    text: '2% for Strongbox Vault',
    color: '#9EEEDB',
  },
  {
    text: '91% for fairlaunch',
    color: '#7e9af9',
  },
];

const BITMAX_TOKENOMICS = [
  {
    text: '15% for creator (5% at TGE, 5% at listing and 5% at 5M market cap)',
    color: '#f9b48f',
  },
  {
    text: '1% for Distilled AI Treasury',
    color: '#f9dd8f',
  },
  {
    text: '1% for Agent Wallet',
    color: '#C2F98F',
  },
  {
    text: '2% for Strongbox Vault',
    color: '#9EEEDB',
  },
  {
    text: '81% for fairlaunch and liquidity',
    color: '#7e9af9',
  },
];

export const TOKENOMICS_LIST = ({
  isMeme = false,
  isRiza = false,
  isBitMax = false,
  isRizaV2 = false,
} = {}) => {
  if (isRiza) return RIZA_TOKENOMICS;
  if (isBitMax) return BITMAX_TOKENOMICS;
  if (isRizaV2) return RIZA_TOKENOMICS_V2;
  return isMeme ? MEME_TOKENOMICS : REGULAR_TOKENOMICS;
};
